// extracted by mini-css-extract-plugin
export default {"performanceChartContainer":"PerformanceChart_performanceChartContainer__naIS4"};